import { DRPProvider } from "./context";
import { useDRP } from "./logics";
import { DRPPopover } from "./popover";
import type { TDateRangePicker } from "./types";

export const DateRangePicker = <Chip extends string = string>({
  open,
  value,
  onClose,
  views,
  chips,
  chip,
  defaultView,
  anchorEl,
  onChange,
  required,
  minDate,
  maxDate,
}: TDateRangePicker<Chip>) => {
  const contextValues = useDRP<Chip>(
    open,
    value,
    onChange,
    defaultView,
    views,
    chips,
    chip,
    anchorEl,
    onClose,
    required,
    minDate,
    maxDate
  );

  return (
    <DRPProvider {...contextValues}>
      <DRPPopover />
    </DRPProvider>
  );
};

export * from "./chips";
export { calculateDateRangePickerChipDate } from "./logics/chips";
export * from "./textfield";
export {
  DateRangePickerViews,
  type IDateRange,
  type IDateRangePickerChip,
  type IDateRangePickerChipDateConfig,
  type TDateRangePicker,
  type TDateRangePickerTextField,
  type TDateRangePickerViews,
} from "./types";
